// extracted by mini-css-extract-plugin
export var buttonContainer = "_6y-1";
export var fontSizeSelect = "_6y-3";
export var formatSelect = "_6y-2";
export var formats = "_6y-4";
export var hidden = "_6y-5";
export var icon = "_6y-6";
export var select = "_6y-0";